import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IADatabaseDocument, IADatabaseSearchAndFilters } from "@/src/types/admissionDatabase";
import {
  admissionDatabaseDefaultBodyFilters,
  admissionDatabaseDefaultConfiguration,
  admissionDatabaseAllFieldsList,
} from "@/src/constants/AdmissionOffice/admissionOfficeDatabaseConsts";
import { getUserConfigFromStorage } from "@/src/utils/userConfigStorage";
// import {
//   onlineApplicationsDefaultConfiguration,
//   onlineApplicationAllFieldsList,
// } from "@/src/constants/applicationOnlineConsts";

interface ColumnConfig {
  title: string;
  id: string;
  width?: number;
}

interface ApplicationsTableState {
  data: IADatabaseDocument[];
  visibleColumns: ColumnConfig[];
  filterAndSearch: IADatabaseSearchAndFilters;
  hiddenColumns: ColumnConfig[];
  // selectedRows: number[];
}

const userConfig = getUserConfigFromStorage();

const initialState: ApplicationsTableState = {
  data: [],
  visibleColumns: userConfig?.AODPConfig?.AODPTable || admissionDatabaseDefaultConfiguration,
  filterAndSearch: admissionDatabaseDefaultBodyFilters,
  hiddenColumns: admissionDatabaseAllFieldsList.filter((col) => !admissionDatabaseDefaultConfiguration.some((def) => def.id === col.id)),
  // selectedRows: [],
};

const AODatabaseTableSlice = createSlice({
  name: "AODatabaseTableSlice",
  initialState,
  reducers: {
    setData(state, action: PayloadAction<IADatabaseDocument[]>) {
      state.data = action.payload;
    },
    setFilterAndSearch(
      state,
      action: PayloadAction<{ key: string; value: string[] | number | string | null } | Record<string, string[] | number | string | null>>
    ) {
      if ("key" in action.payload) {
        // старый формат: { key, value }
        const { key, value } = action.payload;
        if (typeof key === "string") {
          // гарантируем что key — строка
          state.filterAndSearch = {
            ...state.filterAndSearch,
            [key]: value,
          };
        }
      } else {
        // новый формат: { start: value, end: value }
        state.filterAndSearch = {
          ...state.filterAndSearch,
          ...action.payload,
        };
      }
    },
    toggleColumnVisibility(state, action: PayloadAction<string>) {
      const colId = action.payload;
      const isVisible = state.visibleColumns.some((col) => col.id === colId);

      if (isVisible) {
        const col = state.visibleColumns.find((col) => col.id === colId)!;
        state.visibleColumns = state.visibleColumns.filter((col) => col.id !== colId);
        state.hiddenColumns.push({ title: col.title, id: col.id });
      } else {
        let col = state.hiddenColumns.find((col) => col.id === colId);
        if (!col) {
          col = admissionDatabaseAllFieldsList.find((c) => c.id === colId)!;
        }
        state.hiddenColumns = state.hiddenColumns.filter((c) => c.id !== colId);
        state.visibleColumns.push({ title: col.title, id: col.id, width: 4 });
      }
    },
    setColumnWidth(state, action: PayloadAction<{ id: string; width: number }>) {
      const { id, width } = action.payload;
      const col = state.visibleColumns.find((c) => c.id === id);
      if (col) col.width = width;
    },
    // toggleRowSelection(state, action: PayloadAction<number>) {
    //   const id = action.payload;
    //   if (state.selectedRows.includes(id)) {
    //     state.selectedRows = state.selectedRows.filter((rowId) => rowId !== id);
    //   } else {
    //     state.selectedRows.push(id);
    //   }
    // },
    // toggleAllRows(state) {
    //   if (state.selectedRows.length === state.data.length) {
    //     state.selectedRows = [];
    //   } else {
    //     state.selectedRows = state.data.map((row) => row.applyInfo.id);
    //   }
    // },
    // setActualFieldValue(
    //   state,
    //   action: PayloadAction<{ id: number; fieldActualValue: string; keyField: string }>
    // ) {
    //   const { id, fieldActualValue, keyField } = action.payload;
    //   const row = state.data.find((r) => r.applyInfo.id === id);
    //   if (!row) return;

    //   switch (keyField) {
    //     case "color_star":
    //       row.applyInfo.color_star = fieldActualValue;
    //       console.log(`Star color changed for ${id}: ${fieldActualValue}`);
    //       break;

    //     case "form_status":
    //       row.applyInfo.status = fieldActualValue;
    //       console.log(`Status changed for ${id}: ${fieldActualValue}`);
    //       break;

    //     default:
    //       console.warn(`Unknown keyField: ${keyField}`);
    //       break;
    //   }
    // },
    showAllColumns(state) {
      state.visibleColumns = [...admissionDatabaseAllFieldsList];
      state.hiddenColumns = [];
    },
    hideAllColumns(state) {
      state.hiddenColumns = [...admissionDatabaseAllFieldsList];
      state.visibleColumns = [];
    },
    setVisibleColumns(state, action: PayloadAction<ColumnConfig[]>) {
      state.visibleColumns = action.payload;
      // Обновляем hiddenColumns на основе видимых колонок
      state.hiddenColumns = admissionDatabaseAllFieldsList.filter(
        (col) => !action.payload.some((visibleCol) => visibleCol.id === col.id)
      );
    },
  },
});

export const {
  setData,
  setFilterAndSearch,
  toggleColumnVisibility,
  setColumnWidth,
  // toggleRowSelection,
  // toggleAllRows,
  // setActualFieldValue,
  // // setStatus,
  showAllColumns,
  hideAllColumns,
  setVisibleColumns,
} = AODatabaseTableSlice.actions;

export default AODatabaseTableSlice.reducer;
